import React from 'react';
import EditableTextComponent from 'components/Form/EditableText';
import tw from 'twin.macro';
import ButtonLink from 'components/Buttons/Link';
import Button from 'components/Buttons/Button';
import { BreadcrumbItem } from 'components/Breadcrumb2/index';

function renderIcon(
  icon: React.ReactNode | (() => React.ReactNode),
): React.ReactNode {
  if (typeof icon === 'function') {
    return icon();
  }
  return icon;
}

export function BreadcrumbItemContent({
  item,
  isLast,
}: {
  item: BreadcrumbItem;
  isLast: boolean;
}) {
  if (item.editable && typeof item.text === 'string') {
    return (
      <div tw="flex min-w-0 items-center px-1">
        {item.icon && renderIcon(item.icon)}
        <EditableTextComponent
          tw="text-neutral-moderate text-sm font-normal"
          autoSize={false}
          autoFocus={item.editAutoFocus}
          value={item.text}
          onConfirm={item.onEdit || (() => {})}
        />
      </div>
    );
  }

  if (isLast || item.isActive) {
    return (
      <div tw="flex min-w-0 items-center px-1">
        {item.icon && renderIcon(item.icon)}
        <span
          css={[
            tw`text-neutral-moderate text-sm font-normal truncate`,
            item.hideTextOnMobile && tw`hidden md:block`,
            item.hideTextOnDesktop && tw`md:hidden`,
          ]}
        >
          {item?.text}
        </span>
      </div>
    );
  }

  const content = (
    <>
      {item.icon && renderIcon(item.icon)}
      <span
        css={[
          tw`truncate text-neutral-moderate text-sm font-normal min-w-0`,
          item.hideTextOnMobile && tw`hidden lg:block`,
          item.hideTextOnDesktop && tw`lg:hidden`,
        ]}
      >
        {item?.text}
      </span>
    </>
  );

  if (item.to) {
    return (
      <ButtonLink to={item.to} minimal intent="none" tw="px-1 flex">
        {content}
      </ButtonLink>
    );
  }

  if (item.onClick) {
    return (
      <Button onClick={item.onClick} minimal intent="none" tw="px-1 flex">
        {content}
      </Button>
    );
  }

  return <div tw="flex min-w-0 items-center px-1">{content}</div>;
}
